export var getMetaTagsFromBlock = function (block) {
    var _a;
    if (!block || !(block === null || block === void 0 ? void 0 : block.text))
        return [];
    var numberedText = (_a = block === null || block === void 0 ? void 0 : block.text) === null || _a === void 0 ? void 0 : _a.split('\n');
    return numberedText.map(function (text) { return text.trim(); }).filter(function (text) { return text; });
};
//# sourceMappingURL=getMetaTagsFromBlock.js.mapexport var getMetaTagsFromBlock = function (block) {
    var _a;
    if (!block || !(block === null || block === void 0 ? void 0 : block.text))
        return [];
    var numberedText = (_a = block === null || block === void 0 ? void 0 : block.text) === null || _a === void 0 ? void 0 : _a.split('\n');
    return numberedText.map(function (text) { return text.trim(); }).filter(function (text) { return text; });
};
//# sourceMappingURL=getMetaTagsFromBlock.js.map